"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const MemberTypeToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", { className: "member-type-tool-tip" }, "Select Self-Administered Songwriter if you write and/or compose your works and manage some or all of your own catalog."),
        react_1.default.createElement("p", { className: "member-type-tool-tip" }, "Select Publisher if you work at a publishing company and/or are a third-party administrator."),
        react_1.default.createElement("p", { className: "member-type-tool-tip" }, "Select CMO if you work at a CMO.")) }));
exports.default = MemberTypeToolTip;
